import { render, staticRenderFns } from "./CallSounds.vue?vue&type=template&id=64d45d08&"
import script from "./CallSounds.vue?vue&type=script&lang=ts&"
export * from "./CallSounds.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports